import { useEffect, useState } from "react";
import { CustomCalendar } from "../../../../../common/components/Calendar/CustomCalendar";
import { CustomDrawer } from "../../../../../common/components/Drawer/CustomDrawer";
import { FormatDate } from "../../../../../utilities/formatDate";
import { useHolidayCalendarStore } from "../../store/HolidayStore";
import { WorkCalendarService } from "../../core/_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../../../common/components/Loader/Loader";
import { EventContentArg } from "@fullcalendar/core";
import dayjs from "dayjs";
import { DatePicker, Form } from "antd";
import { FormProvider } from "../../../../../common/provider/form/Form.provider";
import { SimpleInput } from "../../../../../common/components/simpleInput";
import { CustomButton } from "../../../../../common/components/CustomButton/CustomButton";
import style from "./style.module.scss";
import { MdOutlineEventBusy } from "react-icons/md";

export const PublicHolidayCalendar = () => {
  const {
    list,
    pageState,
    resetPageState,
    setActioned,
    setList,
    setPageState,
    totalItems,
  } = useHolidayCalendarStore();

  const [form] = Form.useForm();

  const [isOpenDrawer, setIsOpenDrawer] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  useEffect(() => {
    getLists(pageState);
  }, [pageState]);

  useEffect(() => {
    if (!isOpenDrawer) {
      form.resetFields();
    }
  }, [isOpenDrawer]);

  const getLists = async (params: any) => {
    try {
      setIsLoading(true);

      const res = await WorkCalendarService.getHolydays(params);
      if (res?.status === HttpStatusCode.Ok) {
        setList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenDrawer = () => {
    setIsOpenDrawer((prev: boolean) => !prev);
  };

  const handleClickOnDate = (info: any) => {
    const formatData = {
      date: info?.date ? dayjs(info?.date, "YYYY-MM-DD") : null,
      ...(info?.event
        ? {
            label: info?.event?.label,
            ...(info?.event?.id
              ? {
                  id: info?.event?.id,
                }
              : {}),
          }
        : {}),
    };
    form?.setFieldsValue(formatData);
    handleOpenDrawer();
  };

  const formatListData = (data: any) => {
    return data?.map((item: any) => ({
      ...item,
      start: item?.date
        ? dayjs(item?.date, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD")
        : null,
    }));
  };

  const handleSubmit = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const dataToPost = {
        ...values,
        date: values?.date ? FormatDate.formatDateToPostEn(values?.date) : null,
      };

      if (!values?.id) {
        const res = await WorkCalendarService.createHoliday(dataToPost);
        if (res?.status === HttpStatusCode.Created) {
          handleOpenDrawer();
          setPageState({
            ...pageState,
            page: 1,
          });
          form.resetFields();
        }
      } else {
        const res = await WorkCalendarService.patchHoliday(dataToPost);
        if (res?.status === HttpStatusCode.Ok) {
          handleOpenDrawer();
          setPageState({
            ...pageState,
            page: 1,
          });
          form.resetFields();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <>
      <Loader isLoading={isLoading} />

      <CustomDrawer
        title={`${form.getFieldValue("id") ? "Modification" : "Nouveau"}`}
        isOpen={isOpenDrawer}
        onClose={handleOpenDrawer}
      >
        <FormProvider
          Form={Form}
          form={form}
          debug
          onFinish={(values: any) => {
            handleSubmit(values);
          }}
          onFinishFailed={(err) => {
            console.log("err", err);
          }}
        >
          <div className="d-none">
            <SimpleInput Form={Form} name={"id"} label={"ID"} />
          </div>
          <div className="d-flex gap-4">
            <div className="flex-fill">
              <SimpleInput
                Form={Form}
                name={"label"}
                label={"Titre"}
                //   placeholder={"Titre"}
                rules={[
                  {
                    required: true,
                    message: "Ce champ est requis",
                  },
                ]}
              />
            </div>
            <div className="flex-fill">
              <SimpleInput
                Form={Form}
                name={"date"}
                label={"Date"}
                placeholder={"date"}
                rules={[
                  {
                    required: true,
                    message: "Ce champ est requis",
                  },
                ]}
                customInput={
                  <DatePicker
                    disabled
                    placeholder=""
                    className={"w-100"}
                    showNow={false}
                    format={"DD/MM/YYYY"}
                    allowClear={false}
                  />
                }
              />
            </div>
          </div>

          <div className="d-flex justify-content-end w-100 mt-4">
            <CustomButton
              type="submit"
              variant="primary"
              isLoading={isLoadingSubmit}
            >
              Enregistrer
            </CustomButton>
          </div>
        </FormProvider>
      </CustomDrawer>

      <CustomCalendar
        onClick={handleClickOnDate}
        events={formatListData(list)}
        onChangeYear={(year) =>
          setPageState({
            ...pageState,
            "date[after]": `${year}-01-01`,
            "date[before]": `${year}-12-31`,
          })
        }
        renderContent={(e: EventContentArg) => (
          <div
            className={style.holiday__event}
            style={{
              padding: "10px",
            }}
            onClick={() => {
              const formatedData = {
                date: dayjs(e?.event?.start).format("YYYY-MM-DD"),
                event: {
                  ...e?.event?.extendedProps,
                  id: e?.event?.id,
                  date: e?.event?.start,
                },
              };
              handleClickOnDate(formatedData);
            }}
          >
            <div className={style.holiday__event_icon}>
              <MdOutlineEventBusy size={20} />
            </div>
            <span className={style.holiday__event_title}>
              {e?.event?.extendedProps?.label}
            </span>
          </div>
        )}
      />
    </>
  );
};
